import { buildClassName } from './buildClassName';
import type { InteriorOption } from '../types';

export interface InteriorSwatchGroupProps {
  options: InteriorOption[];
  selectedOptionId: string;
  onOptionSelect: (optionId: string) => void;
  /** 이동 모드에서 차량 사양을 잠글 때 true. */
  disabled?: boolean;
}

export function InteriorSwatchGroup({
  options,
  selectedOptionId,
  onOptionSelect,
  disabled = false,
}: InteriorSwatchGroupProps) {
  return (
    <ul className="swatch-list" aria-label="내장 색상 선택">
      {options.map((option) => {
        const isSelected = option.id === selectedOptionId;
        return (
          <li key={option.id}>
            <button
              type="button"
              className={buildClassName('swatch', 'swatch--selected', isSelected)}
              aria-pressed={isSelected}
              aria-label={option.name}
              title={option.name}
              disabled={disabled}
              onClick={() => onOptionSelect(option.id)}
            >
              <span
                className="swatch__color swatch__color--two-tone"
                style={{ background: `linear-gradient(135deg, ${option.seatColor} 50%, ${option.trimColor} 50%)` }}
              />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
